import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_URL + '/api/company';

class CompanyService {
    get(id) {
        return axios.get(API_URL + '/' + id, { headers: authHeader() });
    }

    store(data) {
        return axios.post(API_URL, data, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
    }

    update(id, data) {
        return axios.post(API_URL + '/' + id + '?_method=PUT', data, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
    }

    delete(id) {
        return axios.delete(API_URL + '/' + id, { headers: authHeader() });
    }

    getAllType() {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAll/company_type';
        return axios.get(url, { headers: authHeader() });
    }

    isNameAvailable(data) {
        return axios.post(API_URL + '/' + 'isNameAvailable', data, { headers: authHeader() });
    }

    isCompanyVerified(data) {
        return axios.post(API_URL + '/' + 'isCompanyVerified', data, { headers: authHeader() });
    }

    addBranch(data) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/branch';
        return axios.post(url, data, { headers: authHeader() });
    }

    getAllBranch(company_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAll/branch';
        return axios.get(url + '/' + company_id, { headers: authHeader() });
    }

    getAllLocation() {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAll/location';
        return axios.get(url, { headers: authHeader() });
    }

    getAll() {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAll/company';
        return axios.get(url, { headers: authHeader() });
    }

    getAllProvider() {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAll/provider';
        return axios.get(url, { headers: authHeader() });
    }

    addAccountSubmission(data) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/account_submission';
        return axios.post(url, data, { headers: authHeader() });
    }
}

export default new CompanyService();
